import React, { useEffect, useState } from 'react'
import { Form, Grid, Segment, Button, Dropdown, Message } from 'semantic-ui-react';
import { addTipoServicioLizen, editTipoServicioLizen, getTipoServicio } from '../../../../api/Lizen/tipoServicio';
import { getConvenio } from '../../../../api/Lizen/aseguradora';
import * as Yup from 'yup'
import { useAuth } from '../../../../hooks'
import { toast } from 'react-toastify'
import { useFormik } from 'formik'

import { Link } from "react-router-dom";
import "./AbmAdmin.scss";

const RUTA_LISTADO = '/admin/tipo_servicio_lizen/listado'

export function TipoServicioLizenCreateEditShow(props) {
	const { auth } = useAuth()
	const { history } = props;
	const { id, type_action } = props.match.params
	const disabledGeneral = type_action === "show"
	const isAddMode = !id;
	const [tipoServicio, setTipoServicio] = useState(null)
	const [convenios, setConvenios] = useState([])
	// Solo un usuario sin convenio (admin/CEO) elige el convenio; al resto el back le fuerza el suyo.
	const eligeConvenio = !auth?.me?.aseguradora
	const esGlobal = !!tipoServicio?.es_global

	const formik = useFormik({
		initialValues: initialValues(),
		validationSchema: Yup.object(validationSchema(eligeConvenio && isAddMode)),
		onSubmit: async (formValue) => {
			const body = { codigo: formValue.codigo, nombre: formValue.nombre }
			if (eligeConvenio && isAddMode) body.aseguradora = formValue.aseguradora
			try {
				const response = isAddMode
					? await addTipoServicioLizen(body)
					: await editTipoServicioLizen(id, body)

				if (response.status === "error") {
					toast.error(`No se pudo guardar: ${response.message}`)
				} else {
					toast.success("Se guardó exitosamente el tipo de servicio.", {
						onClose: () => {
							history.push(RUTA_LISTADO);
						},
						autoClose: 1000
					})
				}
			} catch (error) {
				toast.error(JSON.stringify(error.message))
			}
		},
	})

	useEffect(() => {
		if (eligeConvenio) {
			const fetchConvenios = async () => {
				const data = await getConvenio()
				const opciones = (data?.results || []).map((x) => ({ key: x.id, text: x.nombre, value: x.id }))
				setConvenios(opciones)
			}
			fetchConvenios()
		}
		if (!isAddMode) {
			const fetchTipoServicio = async () => {
				const data = await getTipoServicio(id)
				if (!data) return
				formik.setFieldValue("codigo", data.codigo)
				formik.setFieldValue("nombre", data.nombre)
				formik.setFieldValue("aseguradora", data.aseguradora || "")
				setTipoServicio(data)
			}
			fetchTipoServicio()
		}
	}, [])

	const convenioTexto = () => {
		if (esGlobal) return "Global (todos los convenios)"
		return tipoServicio?.aseguradora_nombre || auth?.me?.aseguradora?.nombre || ""
	}

	return (
		<Form className="form-compact" onSubmit={formik.handleSubmit} style={{ display: 'grid' }}>
			<p><strong>Tipo de servicio</strong></p>
			{esGlobal && (
				<Message info content="Tipo de servicio global: está disponible para todos los convenios y no se puede modificar." />
			)}
			<Grid as={Segment}>
				<Grid.Row className='segment_border_primary'>
					<Grid.Column computer={3} mobile={16} tablet={16}>
						<h5>* Código</h5>
						<Form.Input
							disabled={disabledGeneral || esGlobal}
							name="codigo"
							fluid
							maxLength={10}
							placeholder="Ej: VIP"
							value={formik.values.codigo}
							onChange={(_, data) => formik.setFieldValue("codigo", data.value.toUpperCase())}
							error={formik.errors.codigo ? { content: formik.errors.codigo } : false}
						/>
					</Grid.Column>
					<Grid.Column computer={6} mobile={16} tablet={16}>
						<h5>* Nombre</h5>
						<Form.Input
							disabled={disabledGeneral || esGlobal}
							name="nombre"
							fluid
							placeholder="Ingrese un nombre"
							value={formik.values.nombre}
							onChange={(_, data) => formik.setFieldValue("nombre", data.value)}
							error={formik.errors.nombre ? { content: formik.errors.nombre } : false}
						/>
					</Grid.Column>
					<Grid.Column computer={5} mobile={16} tablet={16}>
						<h5>{eligeConvenio && isAddMode ? "* " : ""}Convenio</h5>
						{eligeConvenio && isAddMode ? (
							<Dropdown
								placeholder="Seleccione un convenio"
								name="aseguradora"
								options={convenios}
								value={formik.values.aseguradora}
								onChange={(_, data) => formik.setFieldValue("aseguradora", data.value)}
								selection
								search
								fluid
								error={!!formik.errors.aseguradora}
							/>
						) : (
							<Form.Input fluid disabled value={convenioTexto()} />
						)}
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					{!esGlobal && !disabledGeneral && (
						<Grid.Column computer={2} mobile={16} tablet={16}>
							<Button fluid disabled={formik.isSubmitting} type="submit" content={isAddMode ? "Guardar" : "Actualizar"} primary />
						</Grid.Column>
					)}
					<Grid.Column computer={2} mobile={16} tablet={16}>
						<Button fluid content="Volver" primary component={Link} href={RUTA_LISTADO} />
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Form>
	)
}

function validationSchema(convenioObligatorio) {
	const schema = {
		codigo: Yup.string()
			.required("El código es obligatorio")
			.max(10, "Máximo 10 caracteres")
			.matches(/^[A-Z0-9_-]+$/, "Solo letras, números, guión y guión bajo"),
		nombre: Yup.string().required("El nombre es obligatorio"),
	}
	if (convenioObligatorio) {
		schema.aseguradora = Yup.number().required("Debe seleccionar un convenio")
	}
	return schema
}

function initialValues() {
	return {
		codigo: "",
		nombre: "",
		aseguradora: "",
	}
}
